/* eslint-disable */
// @ts-ignore
window.__pegasus_commit_hash__ = process.env.GIT_COMMIT
